import {Component, OnInit} from "@angular/core";
import {TabsPageContainer} from "../../../uiComponents/tabsPageContainer";

@Component({
	selector: 'rules-and-policies-tabs',
	templateUrl: './rules-and-policies-tabs.component.html',
})
export class RulesAndPoliciesTabsComponent extends TabsPageContainer implements OnInit {
	visibleTabs = [];

	ngOnInit() {
		const allTabs = this.dic.CONSTANTS.outboundRulesAndPoliciesPageTabs;
		this.visibleTabs = Object.entries(allTabs)
			.filter(([tabKey]) => {
				if (tabKey === 'rules' || tabKey === 'policies') {
					return this.gs.userInfo?.outboundAllowRules !== false;
				}
				if (tabKey === 'emailSignatures') {
					return this.gs.userInfo?.outboundAllowEmailSignatures !== false;
				}
				return true;
			})
			.map(([tabKey, tabValue]) => ({key: tabKey, value: tabValue}));
	}
}
